var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { buildOdataQuery } from "@ane/core/lib/utils/ODataUtils";
import { parseError } from "@ane/core/lib/utils/ErrorUtils";
import { noCache } from "../../services/middlewares/NoCacheMiddleware.js";
import { getUnifiedApiVersion } from "./ExpAPIVUnified.constants.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let AssignmentScopeResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.default, "/workspaces/", parseError);
  }
  queryAssignmentScopes(workspaceId, odataQueryOptions, additionalQueryParams) {
    return __async(this, null, function* () {
      const url = buildOdataQuery(odataQueryOptions, {
        baseUrl: `${workspaceId}/assignment-scopes`,
        cleanOdataDollarSignPrefix: true,
        additionalQueryParams: __spreadProps(__spreadValues({}, additionalQueryParams), {
          "api-version": getUnifiedApiVersion()
        })
      });
      return yield this._get(url);
    });
  }
};
AssignmentScopeResource = __decorateClass([
  noCache(),
  WPSProxyConverter()
], AssignmentScopeResource);
const AssignmentScopes_resource = new AssignmentScopeResource();
export {
  AssignmentScopeResource,
  AssignmentScopes_resource as default
};
//# sourceMappingURL=AssignmentScopes.resource.js.map
